// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lora:wght@400;500&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styles */

body, html {
  margin: 0;
  padding: 0;
  font-family: 'Raleway', sans-serif;

  background-color: #f5f5f5;
}

/* Navbar Container */
.navbar {
  background-color: #142651;
  color: #fff;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.navbar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
  position: relative;
  top: 0%;
}

.logo-container {
  margin-left: -10; /* Ensure no margin pushes it inward */
  display: flex;
  align-items: center;
}

.logo {
  height: 50px;
  margin-left: -10px;
  font-family: 'Raleway', sans-serif;

}

.brand {
  display: flex;
  margin-left: -10;
  align-items: center;
  text-decoration: none;
  color: #fff;
  font-weight: bold;
  font-family: 'Raleway', sans-serif;

  font-size: 0.9rem;
}

.hamburger {
  display: none;
  background: none;
  border: none;
  font-size: 2rem;
  font-family: 'Raleway', sans-serif;
  color: #fff;
  cursor: pointer;
}

/* Navigation Menu */
.nav-menu {
  display: flex;
  align-items: center;
  transition: max-height 0.3s ease;
}

.nav-menu.open {
  max-height: fit-content;
}

.nav-list {
  display: flex;
  list-style: none;
  gap: 0px; /* Adjust this to reduce spacing */
  margin: 0;
  padding: 0;

}

.dropdown-column {
  padding: 10px;
}
.dropdown-menu * {
  margin: 0;
  padding: 0 15px;
}

.nav-item {
  position: relative;
  margin: 0; /* Remove default margins */
  /* padding: 0 15px; Adjust horizontal padding */
} 
 .dropdown{
  position: static !important;
 }

.nav-link,
.dropdown-toggle {
  color: #fff;
  text-decoration: none;
  padding: 8px 14px;
  display: block;
  cursor: pointer;
  font-size: 1rem;
}
.nav-link::before{
  content: "";
  position: absolute;
  right: 0px;
  bottom: 0;
  height: 3px;
  width: 100%;
  background: rgb(173, 204, 238) ;
  border-radius: 50px;
  transform: scaleX(0);
  transition: transform 0.2s  linear;
  z-index: 100000;
}
.nav-link:hover::before{
  transform: scaleX(1);
}
/* Dropdown Menu */
/* Dropdown Menu - Center Alignment and Full Width */
.dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  right: 0; /* Start from the left edge of the navbar */
  background: none;
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */
  /* border-radius: 5px; */
  padding: 10; 
  padding-left: 110px;
  z-index: 100;
  white-space: nowrap;
  font-size: 0.85rem; /* Smaller font size for dropdown menus */
  text-align: left; /* Center align all text within the dropdown */
  flex-direction: column;
  font-family: 'Raleway', sans-serif;

}



/* Submenus Alignment (Left-Aligned) */
.dropdown-menu .dropdown-submenu {
  text-align: left; /* Override center alignment for submenus */
  padding-left: 10px; /* Add some padding to offset submenu items */
  margin: 0; /* Remove extra spacing */
}

.dropdown-menu .submenu-item {
  text-align: left; /* Ensure submenu items are left-aligned */
  margin: 0px 0; /* Add a small margin between submenu items */
}

.dropdown-menu.multi-column {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 3 columns */
  gap: 10px; /* Reduce space between columns and rows */
  margin: 0 auto; /* Center the dropdown content */
  padding: 50px; /* Reduce padding for the overall container */
  background-color: #ffffff; /* Dropdown background color */
  border-radius: 3px;
  width: 100%; /* Full width but responsive */
  height: auto; /* Default dynamic height */
  overflow-y: auto; /* Allow scrolling if needed */
  overflow-x: hidden; /* Prevent horizontal scrolling */
}

.dropdown-menu * { margin: 0; padding: 0 15px; } /* Reduce horizontal spacing */


/* For screens with max-width of 1200px, reduce to 3 columns */
@media screen and (max-width: 1500px) {
  .dropdown-menu.multi-column {
    grid-template-columns: repeat(3, 1fr); /* Switch to 3 columns */
  }
  .nav-link,
  .dropdown-toggle{
    font-size: 0.8rem;
  }
 .nav-link:hover,
.dropdown-toggle:hover {
  /* background-color: #004080; */
  /* border-radius: 4px; */
  transition:all 0.3s ease-in-out;
  transform: scale(1.3);
}
}

/* For screens with max-width of 992px, reduce to 2 columns */
@media screen and (max-width: 1170px) {
  .dropdown-menu.multi-column {
    grid-template-columns: repeat(1, 1fr); /* Switch to 2 columns */
    gap: 8px; /* Reduce spacing for smaller screens */
    padding: 15px; /* Adjust padding for smaller screens */
  }
  .nav-link,
  .dropdown-toggle{
    font-size: 0.7rem;
  }
}

/* For screens with max-width of 768px, reduce to 1 column */
@media screen and (max-width: 768px) {
  .dropdown-menu.multi-column {
    grid-template-columns: 1fr; /* Single column for smaller screens */
    gap: 5px; /* Minimize spacing */
    padding: 10px; /* Compact padding */
    max-height: 70vh; /* Limit height for smaller screens */
    overflow-y: auto; /* Enable vertical scrolling */
  }
}



/* Dropdown Column Styling */
/* Dropdown Column Styling */
.dropdown-column {
  padding: 10px;
}

.dropdown-column h4 {
  color: #0e3a45;
  margin-bottom: 5px;
  font-size: 1rem; /* Adjust headings for visibility */
  font-family: 'Raleway', sans-serif;

}

.dropdown-submenu {
  list-style: none;
  padding: 2;
  margin: 0;
}

.submenu-item {
  margin-bottom: 0px;
}

.dropdown-link {
  padding: 5px 0; /* Reduce padding around links */
  font-size: 0.9rem; /* Adjust font size */
  font-family: 'Raleway', sans-serif;

  margin: 0; /* Remove any default margins */
  display: block;
}

.dropdown-link:hover {
  text-decoration: underline;
}

/* Active Dropdown */
.nav-item.dropdown .dropdown-toggle.open + .dropdown-menu {
  display: flex;
}

/* Responsive */
/* Default Styles (Desktop View) */
.hamburger {
  display: none; /* Hidden by default */
}

.nav-menu {
  display: flex; /* Default to flex for desktop view */
}
/* for large screen responsive  */
@media screen and (max-width: 1100px) {
  .navbar-container {
    flex-direction: column; /* Stack the logo and menu vertically */
    align-items: center; /* Center the logo and menu */
  }

  .navbar {
    max-height: 100vh;
    overflow-y: scroll; /* Vertical scrolling only */
    overflow-x: hidden; /* Prevent horizontal scrolling */
  }

  .navbar::-webkit-scrollbar {
    width: 0;
  }

  .logo-container {
    display: flex;
    align-items: center;
    margin-bottom: 10px; /* Add spacing between the logo and menu */
    justify-content: space-between;
    width: 100%;
  }

  .logo {
    height: 40px;
    margin: 0; /* Remove extra margins */
  }

  .brand {
    font-size: 1rem;
    margin: 0; /* Remove extra margins */
  }

  .hamburger {
    display: block;
    margin-top: 0px;
  }

  .nav-menu {
    display: none;
    flex-direction: column;
    width: 100%; /* Full width for dropdown */
    text-align: center;
  }

  .nav-menu.open {
    display: flex;
  }

  .nav-list {
    flex-direction: column;
    width: 100%;
    padding: 0;
  }

  .nav-item {
    width: 100%;
    margin: 0;
  }

  .nav-link,
  .dropdown-toggle {
    width: 100%;
    text-align: center;
    font-family: 'Raleway', sans-serif;
    padding: 10px 0; /* Further reduced padding */
    font-size: 0.9rem;
    color: #fff;
    display: flex;
  }

  .nav-link:hover,
  .dropdown-toggle:hover {
  background-color: #004080;
  border-radius: 4px;
  /* transition:all 0.3s ease-in-out; */
  transform: scale(1);
}
 .nav-link::before{
  width: 0%;
}

  .dropdown-menu {
    position: relative;
    flex-direction: column;
    width: 100% !important;
    box-shadow: none;
    padding: 0; /* Removed all padding */
  }

  .dropdown-menu.multi-column {
    grid-template-columns: 1fr; /* Single column for smaller screens */
    padding: 0; /* Removed padding */
    gap: 0; /* Removed gap between items */
    overflow-x: hidden; /* Prevent horizontal scrolling */
  }

  .dropdown-column h4 {
    font-size: 0.7rem;
    font-weight: bold;
    color: #b1c0ff;
    font-family: 'Raleway', sans-serif;

    margin: 0; /* Removed all margin */
    padding: 2px 0; /* Add small padding for separation */
  }

  .dropdown-submenu {
    padding-left: 5px; /* Slightly indented submenus */
    margin: 0; /* Removed all margin */
    padding: 2px 0; /* Add small padding for separation */
  }

  .dropdown-link {
    padding: 2px 0; /* Reduced padding further */
    font-size: 0.6rem; /* Slightly smaller font size for links */
    color: #fff;
    font-family: 'Raleway', sans-serif;

  }

  .dropdown-menu.multi-column {
    margin-bottom: 0;
    margin-left: 0 auto;
    height: fit-content;
    width: fit-content;
    background-color: #020d1700;
    border-radius: 0;
    border-color: #00336628;
    font-size: 0.7rem;
  }

  .dropdown-menu.multi-column::-webkit-scrollbar {
    width: 0px;
  }

  .dropdown-menu.multi-column::-webkit-scrollbar-thumb {
    background-color: #004488;
    border-radius: 5px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/NewNavbar.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAMnB;EACE,SAAS;EACT,UAAU;EACV,kCAAkC;;EAElC,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,gBAAgB,EAAE,sCAAsC;EACxD,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;;AAEpC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,kCAAkC;;EAElC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,WAAW;EACX,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,QAAQ,EAAE,kCAAkC;EAC5C,SAAS;EACT,UAAU;;AAEZ;;AAEA;EACE,aAAa;AACf;AACA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,2BAA2B;EACtC,+CAA+C;AACjD;CACC;EACC,2BAA2B;CAC5B;;AAED;;EAEE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA,kBAAkB;AAClB,oDAAoD;AACpD;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,QAAQ,EAAE,2CAA2C;EACrD,gBAAgB;EAChB,8CAA8C;EAC9C,wBAAwB;EACxB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB,EAAE,yCAAyC;EAC7D,gBAAgB,EAAE,8CAA8C;EAChE,sBAAsB;EACtB,kCAAkC;;AAEpC;;;;AAIA,sCAAsC;AACtC;EACE,gBAAgB,EAAE,2CAA2C;EAC7D,kBAAkB,EAAE,6CAA6C;EACjE,SAAS,EAAE,yBAAyB;AACtC;;AAEA;EACE,gBAAgB,EAAE,0CAA0C;EAC5D,aAAa,EAAE,6CAA6C;AAC9D;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,cAAc;EACrD,SAAS,EAAE,0CAA0C;EACrD,cAAc,EAAE,gCAAgC;EAChD,aAAa,EAAE,6CAA6C;EAC5D,yBAAyB,EAAE,8BAA8B;EACzD,kBAAkB;EAClB,WAAW,EAAE,8BAA8B;EAC3C,YAAY,EAAE,2BAA2B;EACzC,gBAAgB,EAAE,8BAA8B;EAChD,kBAAkB,EAAE,iCAAiC;AACvD;;AAEA,mBAAmB,SAAS,EAAE,eAAe,EAAE,EAAE,8BAA8B;;;AAG/E,8DAA8D;AAC9D;EACE;IACE,qCAAqC,EAAE,wBAAwB;EACjE;EACA;;IAEE,iBAAiB;EACnB;CACD;;EAEC,+BAA+B;EAC/B,wBAAwB;EACxB,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;;AAEA,6DAA6D;AAC7D;EACE;IACE,qCAAqC,EAAE,wBAAwB;IAC/D,QAAQ,EAAE,uCAAuC;IACjD,aAAa,EAAE,uCAAuC;EACxD;EACA;;IAEE,iBAAiB;EACnB;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,0BAA0B,EAAE,sCAAsC;IAClE,QAAQ,EAAE,qBAAqB;IAC/B,aAAa,EAAE,oBAAoB;IACnC,gBAAgB,EAAE,qCAAqC;IACvD,gBAAgB,EAAE,8BAA8B;EAClD;AACF;;;;AAIA,4BAA4B;AAC5B,4BAA4B;AAC5B;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe,EAAE,mCAAmC;EACpD,kCAAkC;;AAEpC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,gCAAgC;EAChD,iBAAiB,EAAE,qBAAqB;EACxC,kCAAkC;;EAElC,SAAS,EAAE,+BAA+B;EAC1C,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,aAAa;AACf;;AAEA,eAAe;AACf,kCAAkC;AAClC;EACE,aAAa,EAAE,sBAAsB;AACvC;;AAEA;EACE,aAAa,EAAE,qCAAqC;AACtD;AACA,iCAAiC;AACjC;EACE;IACE,sBAAsB,EAAE,uCAAuC;IAC/D,mBAAmB,EAAE,6BAA6B;EACpD;;EAEA;IACE,iBAAiB;IACjB,kBAAkB,EAAE,4BAA4B;IAChD,kBAAkB,EAAE,iCAAiC;EACvD;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB,EAAE,0CAA0C;IAC/D,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,SAAS,EAAE,yBAAyB;EACtC;;EAEA;IACE,eAAe;IACf,SAAS,EAAE,yBAAyB;EACtC;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW,EAAE,4BAA4B;IACzC,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,kCAAkC;IAClC,eAAe,EAAE,4BAA4B;IAC7C,iBAAiB;IACjB,WAAW;IACX,aAAa;EACf;;EAEA;;EAEA,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;CACC;EACC,SAAS;AACX;;EAEE;IACE,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,UAAU,EAAE,wBAAwB;EACtC;;EAEA;IACE,0BAA0B,EAAE,sCAAsC;IAClE,UAAU,EAAE,oBAAoB;IAChC,MAAM,EAAE,8BAA8B;IACtC,kBAAkB,EAAE,iCAAiC;EACvD;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,kCAAkC;;IAElC,SAAS,EAAE,uBAAuB;IAClC,cAAc,EAAE,qCAAqC;EACvD;;EAEA;IACE,iBAAiB,EAAE,+BAA+B;IAClD,SAAS,EAAE,uBAAuB;IAClC,cAAc,EAAE,qCAAqC;EACvD;;EAEA;IACE,cAAc,EAAE,4BAA4B;IAC5C,iBAAiB,EAAE,yCAAyC;IAC5D,WAAW;IACX,kCAAkC;;EAEpC;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;AACF","sourcesContent":["/* General Styles */\r\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Lora:wght@400;500&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600&display=swap\");\r\n\r\nbody, html {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: 'Raleway', sans-serif;\r\n\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n/* Navbar Container */\r\n.navbar {\r\n  background-color: #142651;\r\n  color: #fff;\r\n  position: sticky;\r\n  top: 0;\r\n  width: 100%;\r\n  z-index: 1000;\r\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.navbar-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin: 0 auto;\r\n  padding: 0 20px;\r\n  width: 100%;\r\n  position: relative;\r\n  top: 0%;\r\n}\r\n\r\n.logo-container {\r\n  margin-left: -10; /* Ensure no margin pushes it inward */\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.logo {\r\n  height: 50px;\r\n  margin-left: -10px;\r\n  font-family: 'Raleway', sans-serif;\r\n\r\n}\r\n\r\n.brand {\r\n  display: flex;\r\n  margin-left: -10;\r\n  align-items: center;\r\n  text-decoration: none;\r\n  color: #fff;\r\n  font-weight: bold;\r\n  font-family: 'Raleway', sans-serif;\r\n\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.hamburger {\r\n  display: none;\r\n  background: none;\r\n  border: none;\r\n  font-size: 2rem;\r\n  font-family: 'Raleway', sans-serif;\r\n  color: #fff;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Navigation Menu */\r\n.nav-menu {\r\n  display: flex;\r\n  align-items: center;\r\n  transition: max-height 0.3s ease;\r\n}\r\n\r\n.nav-menu.open {\r\n  max-height: fit-content;\r\n}\r\n\r\n.nav-list {\r\n  display: flex;\r\n  list-style: none;\r\n  gap: 0px; /* Adjust this to reduce spacing */\r\n  margin: 0;\r\n  padding: 0;\r\n\r\n}\r\n\r\n.dropdown-column {\r\n  padding: 10px;\r\n}\r\n.dropdown-menu * {\r\n  margin: 0;\r\n  padding: 0 15px;\r\n}\r\n\r\n.nav-item {\r\n  position: relative;\r\n  margin: 0; /* Remove default margins */\r\n  /* padding: 0 15px; Adjust horizontal padding */\r\n} \r\n .dropdown{\r\n  position: static !important;\r\n }\r\n\r\n.nav-link,\r\n.dropdown-toggle {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  padding: 8px 14px;\r\n  display: block;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n}\r\n.nav-link::before{\r\n  content: \"\";\r\n  position: absolute;\r\n  right: 0px;\r\n  bottom: 0;\r\n  height: 3px;\r\n  width: 100%;\r\n  background: rgb(173, 204, 238) ;\r\n  border-radius: 50px;\r\n  transform: scaleX(0);\r\n  transition: transform 0.2s  linear;\r\n  z-index: 100000;\r\n}\r\n.nav-link:hover::before{\r\n  transform: scaleX(1);\r\n}\r\n/* Dropdown Menu */\r\n/* Dropdown Menu - Center Alignment and Full Width */\r\n.dropdown-menu {\r\n  display: none;\r\n  position: absolute;\r\n  top: 100%;\r\n  right: 0; /* Start from the left edge of the navbar */\r\n  background: none;\r\n  /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */\r\n  /* border-radius: 5px; */\r\n  padding: 10; \r\n  padding-left: 110px;\r\n  z-index: 100;\r\n  white-space: nowrap;\r\n  font-size: 0.85rem; /* Smaller font size for dropdown menus */\r\n  text-align: left; /* Center align all text within the dropdown */\r\n  flex-direction: column;\r\n  font-family: 'Raleway', sans-serif;\r\n\r\n}\r\n\r\n\r\n\r\n/* Submenus Alignment (Left-Aligned) */\r\n.dropdown-menu .dropdown-submenu {\r\n  text-align: left; /* Override center alignment for submenus */\r\n  padding-left: 10px; /* Add some padding to offset submenu items */\r\n  margin: 0; /* Remove extra spacing */\r\n}\r\n\r\n.dropdown-menu .submenu-item {\r\n  text-align: left; /* Ensure submenu items are left-aligned */\r\n  margin: 0px 0; /* Add a small margin between submenu items */\r\n}\r\n\r\n.dropdown-menu.multi-column {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr); /* 3 columns */\r\n  gap: 10px; /* Reduce space between columns and rows */\r\n  margin: 0 auto; /* Center the dropdown content */\r\n  padding: 50px; /* Reduce padding for the overall container */\r\n  background-color: #ffffff; /* Dropdown background color */\r\n  border-radius: 3px;\r\n  width: 100%; /* Full width but responsive */\r\n  height: auto; /* Default dynamic height */\r\n  overflow-y: auto; /* Allow scrolling if needed */\r\n  overflow-x: hidden; /* Prevent horizontal scrolling */\r\n}\r\n\r\n.dropdown-menu * { margin: 0; padding: 0 15px; } /* Reduce horizontal spacing */\r\n\r\n\r\n/* For screens with max-width of 1200px, reduce to 3 columns */\r\n@media screen and (max-width: 1500px) {\r\n  .dropdown-menu.multi-column {\r\n    grid-template-columns: repeat(3, 1fr); /* Switch to 3 columns */\r\n  }\r\n  .nav-link,\r\n  .dropdown-toggle{\r\n    font-size: 0.8rem;\r\n  }\r\n .nav-link:hover,\r\n.dropdown-toggle:hover {\r\n  /* background-color: #004080; */\r\n  /* border-radius: 4px; */\r\n  transition:all 0.3s ease-in-out;\r\n  transform: scale(1.3);\r\n}\r\n}\r\n\r\n/* For screens with max-width of 992px, reduce to 2 columns */\r\n@media screen and (max-width: 1170px) {\r\n  .dropdown-menu.multi-column {\r\n    grid-template-columns: repeat(1, 1fr); /* Switch to 2 columns */\r\n    gap: 8px; /* Reduce spacing for smaller screens */\r\n    padding: 15px; /* Adjust padding for smaller screens */\r\n  }\r\n  .nav-link,\r\n  .dropdown-toggle{\r\n    font-size: 0.7rem;\r\n  }\r\n}\r\n\r\n/* For screens with max-width of 768px, reduce to 1 column */\r\n@media screen and (max-width: 768px) {\r\n  .dropdown-menu.multi-column {\r\n    grid-template-columns: 1fr; /* Single column for smaller screens */\r\n    gap: 5px; /* Minimize spacing */\r\n    padding: 10px; /* Compact padding */\r\n    max-height: 70vh; /* Limit height for smaller screens */\r\n    overflow-y: auto; /* Enable vertical scrolling */\r\n  }\r\n}\r\n\r\n\r\n\r\n/* Dropdown Column Styling */\r\n/* Dropdown Column Styling */\r\n.dropdown-column {\r\n  padding: 10px;\r\n}\r\n\r\n.dropdown-column h4 {\r\n  color: #0e3a45;\r\n  margin-bottom: 5px;\r\n  font-size: 1rem; /* Adjust headings for visibility */\r\n  font-family: 'Raleway', sans-serif;\r\n\r\n}\r\n\r\n.dropdown-submenu {\r\n  list-style: none;\r\n  padding: 2;\r\n  margin: 0;\r\n}\r\n\r\n.submenu-item {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.dropdown-link {\r\n  padding: 5px 0; /* Reduce padding around links */\r\n  font-size: 0.9rem; /* Adjust font size */\r\n  font-family: 'Raleway', sans-serif;\r\n\r\n  margin: 0; /* Remove any default margins */\r\n  display: block;\r\n}\r\n\r\n.dropdown-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Active Dropdown */\r\n.nav-item.dropdown .dropdown-toggle.open + .dropdown-menu {\r\n  display: flex;\r\n}\r\n\r\n/* Responsive */\r\n/* Default Styles (Desktop View) */\r\n.hamburger {\r\n  display: none; /* Hidden by default */\r\n}\r\n\r\n.nav-menu {\r\n  display: flex; /* Default to flex for desktop view */\r\n}\r\n/* for large screen responsive  */\r\n@media screen and (max-width: 1100px) {\r\n  .navbar-container {\r\n    flex-direction: column; /* Stack the logo and menu vertically */\r\n    align-items: center; /* Center the logo and menu */\r\n  }\r\n\r\n  .navbar {\r\n    max-height: 100vh;\r\n    overflow-y: scroll; /* Vertical scrolling only */\r\n    overflow-x: hidden; /* Prevent horizontal scrolling */\r\n  }\r\n\r\n  .navbar::-webkit-scrollbar {\r\n    width: 0;\r\n  }\r\n\r\n  .logo-container {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 10px; /* Add spacing between the logo and menu */\r\n    justify-content: space-between;\r\n    width: 100%;\r\n  }\r\n\r\n  .logo {\r\n    height: 40px;\r\n    margin: 0; /* Remove extra margins */\r\n  }\r\n\r\n  .brand {\r\n    font-size: 1rem;\r\n    margin: 0; /* Remove extra margins */\r\n  }\r\n\r\n  .hamburger {\r\n    display: block;\r\n    margin-top: 0px;\r\n  }\r\n\r\n  .nav-menu {\r\n    display: none;\r\n    flex-direction: column;\r\n    width: 100%; /* Full width for dropdown */\r\n    text-align: center;\r\n  }\r\n\r\n  .nav-menu.open {\r\n    display: flex;\r\n  }\r\n\r\n  .nav-list {\r\n    flex-direction: column;\r\n    width: 100%;\r\n    padding: 0;\r\n  }\r\n\r\n  .nav-item {\r\n    width: 100%;\r\n    margin: 0;\r\n  }\r\n\r\n  .nav-link,\r\n  .dropdown-toggle {\r\n    width: 100%;\r\n    text-align: center;\r\n    font-family: 'Raleway', sans-serif;\r\n    padding: 10px 0; /* Further reduced padding */\r\n    font-size: 0.9rem;\r\n    color: #fff;\r\n    display: flex;\r\n  }\r\n\r\n  .nav-link:hover,\r\n  .dropdown-toggle:hover {\r\n  background-color: #004080;\r\n  border-radius: 4px;\r\n  /* transition:all 0.3s ease-in-out; */\r\n  transform: scale(1);\r\n}\r\n .nav-link::before{\r\n  width: 0%;\r\n}\r\n\r\n  .dropdown-menu {\r\n    position: relative;\r\n    flex-direction: column;\r\n    width: 100% !important;\r\n    box-shadow: none;\r\n    padding: 0; /* Removed all padding */\r\n  }\r\n\r\n  .dropdown-menu.multi-column {\r\n    grid-template-columns: 1fr; /* Single column for smaller screens */\r\n    padding: 0; /* Removed padding */\r\n    gap: 0; /* Removed gap between items */\r\n    overflow-x: hidden; /* Prevent horizontal scrolling */\r\n  }\r\n\r\n  .dropdown-column h4 {\r\n    font-size: 0.7rem;\r\n    font-weight: bold;\r\n    color: #b1c0ff;\r\n    font-family: 'Raleway', sans-serif;\r\n\r\n    margin: 0; /* Removed all margin */\r\n    padding: 2px 0; /* Add small padding for separation */\r\n  }\r\n\r\n  .dropdown-submenu {\r\n    padding-left: 5px; /* Slightly indented submenus */\r\n    margin: 0; /* Removed all margin */\r\n    padding: 2px 0; /* Add small padding for separation */\r\n  }\r\n\r\n  .dropdown-link {\r\n    padding: 2px 0; /* Reduced padding further */\r\n    font-size: 0.6rem; /* Slightly smaller font size for links */\r\n    color: #fff;\r\n    font-family: 'Raleway', sans-serif;\r\n\r\n  }\r\n\r\n  .dropdown-menu.multi-column {\r\n    margin-bottom: 0;\r\n    margin-left: 0 auto;\r\n    height: fit-content;\r\n    width: fit-content;\r\n    background-color: #020d1700;\r\n    border-radius: 0;\r\n    border-color: #00336628;\r\n    font-size: 0.7rem;\r\n  }\r\n\r\n  .dropdown-menu.multi-column::-webkit-scrollbar {\r\n    width: 0px;\r\n  }\r\n\r\n  .dropdown-menu.multi-column::-webkit-scrollbar-thumb {\r\n    background-color: #004488;\r\n    border-radius: 5px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
